import React from 'react';
import notificationSvg from '../../assets/icons/icons8-notification.svg';

interface NotificationIconProps {
  size?: number;
  className?: string;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={notificationSvg} 
      alt="Notification Icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default NotificationIcon;
